import { useState } from 'react';

import { useIsAdmin } from '../auth/hooks/useIsAdmin';

import {
  Button,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Typography,
  ListSubheader,
} from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import { grey } from '@mui/material/colors';
import ShareWeatherWallsDialog from './ShareWeatherWallsDialog';
import { useWeatherWalls } from './api/getWeatherWalls';

const ShareWallsSelectionPage = () => {
  const { user } = useAppSelector((state) => state.auth);

  const [selectedWallIds, setSelectedWallIds] = useState<number[]>([]);
  const [highlightedWallId, setHighlightedWallId] = useState(-1);
  const { data: walls } = useWeatherWalls(user?.id);

  const isAdmin = useIsAdmin();

  const [wallShareDialogOpen, setWallShareDialogOpen] = useState(false);

  const handleWallClicked = (wallId: number) => {
    setHighlightedWallId(wallId);
    if (selectedWallIds.includes(wallId))
      setSelectedWallIds(selectedWallIds.filter((id) => id !== wallId));
    else setSelectedWallIds((priorIds) => [...priorIds, wallId]);
  };

  const handleShareDialogClosed = () => {
    setWallShareDialogOpen(false);
  };

  return (
    <>
      {isAdmin && (
        <ShareWeatherWallsDialog
          open={wallShareDialogOpen}
          handleClose={handleShareDialogClosed}
          selectedWallIds={selectedWallIds}
        />
      )}
      <Grid container spacing={2}>
        <Grid item container>
          <Grid item component={Paper} xs>
            <List sx={{ overflow: 'auto', maxHeight: '80vh' }}>
              <ListSubheader>Select Walls To Share</ListSubheader>
              {walls?.map((wall) => (
                <ListItem
                  key={wall.id}
                  button
                  selected={highlightedWallId === wall.id}
                  onClick={() => handleWallClicked(wall.id)}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge='start'
                      tabIndex={-1}
                      checked={selectedWallIds.includes(wall.id)}
                    />
                  </ListItemIcon>
                  <ListItemText>{wall.name}</ListItemText>
                </ListItem>
              ))}
            </List>
            {!walls ||
              (walls.length === 0 && (
                <Typography
                  color={grey[500]}
                  sx={{ pt: '2rem', pl: '2rem', pb: '2rem' }}
                >
                  No walls found.
                </Typography>
              ))}
          </Grid>
        </Grid>
        <Grid container item xs={12} spacing={1} justifyContent='flex-end'>
          {isAdmin && (
            <Grid item>
              <Button
                variant='contained'
                color='primary'
                disabled={selectedWallIds.length < 1}
                onClick={() => setWallShareDialogOpen(true)}
              >
                Share Selected Walls
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ShareWallsSelectionPage;
